import axios from 'axios';
import { auth, appCheck } from './firebase'; // Import auth and the new appCheck instance
import { getToken } from 'firebase/app-check'; // Keep getToken for type definitions

const BEXORG_GCP_API = '/api2';

const api = axios.create({
    baseURL: BEXORG_GCP_API,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Request interceptor for adding Firebase ID token and App Check token
api.interceptors.request.use(
    async (config) => {
        // Add Firebase ID token (user authentication)
        const currentUser = auth.currentUser;
        if (currentUser) {
            try {
                const idToken = await currentUser.getIdToken();
                config.headers['Authorization'] = `Bearer ${idToken}`;
            } catch (error) {
                console.error('Failed to get Firebase ID token:', error);
                // Optionally handle the error, e.g., redirect to login
            }
        }

        // Add Firebase App Check token (app authentication)
        if (typeof window !== 'undefined' && appCheck) { // Ensure runs on client-side and appCheck is initialized
            try {
                const appCheckTokenResponse = await getToken(appCheck, /* forceRefresh= */ false);
                if (appCheckTokenResponse.token) {
                    config.headers['X-Firebase-AppCheck'] = appCheckTokenResponse.token;
                } else {
                    console.warn("App Check token not available on client.");
                }
            } catch (error) {
                console.error("Error getting App Check token on client:", error);
                // Depending on your requirements, you might want to prevent the request or log out
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for handling auth errors
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // Unauthorized or Forbidden.
            // The Firebase token might be invalid or expired.
            // The SDK handles token refresh, but a persistent 401/403 could mean
            // the user's session is truly invalid.
            console.error('Authorization error. Redirecting to login.');

            // Redirect to login page
            if (typeof window !== 'undefined') {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default api; 